<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="text-h6 font-weight-black mt-1">
        {{ party.name }}
      </div>
      <div
        v-if="party.casePartyRole == casePartyRoleEnum.defendant && party.casePartyStatusId == casePartyStatus.abandoned"
        class="font-weight-black mt-1"
      >
        <v-chip
          label
          small
        >
          {{ local.common.abandoned }}
        </v-chip>
      </div>
    </div>

    <div class="mt-3">
      <v-chip
        v-if="party.casePartyRoleName"
        class="ma-2"
        :text-color="casePartyRoleTextColor"
        :color="casePartyRoleChipColor"
        :outlined="!casePartyRoleChipColor"
      >
        {{ party.casePartyRoleName }}
      </v-chip>
      <v-chip
        v-if="party.partyReferenceName"
        outlined
        class="mx-1"
      >
        {{ local.caseFile.partiesCard.casePartyRole }}:{{ party.partyReferenceName }}
      </v-chip>
      <v-chip
        v-if="party.identityType && party.identityNumber"
        outlined
        class="mx-1"
      >
        {{ party.identityType }} : {{ party.identityNumber }}
      </v-chip>
      <v-chip
        v-if="party.nationalityName"
        outlined
        class="mx-1"
      >
        {{ local.caseFile.partiesCard.nationality }} : {{ party.nationalityName }}
      </v-chip>
      <template v-if="party.subs && party.subs.length> 0 ">
        <hr>
        <v-timeline
          dense
          clipped
          class="pa-0"
        >
          <v-timeline-item
            v-for="sub in party.subs"
            :key="sub.id"
            class="pa-0"
            color="grey"
            icon-color="white"
            small
          >
            <v-row justify="space-between">
              <v-col cols="12">
                <parties-info-card :party="sub"></parties-info-card>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </template>
    </div>
  </div>
</template>

<script>
import { casePartyRoleEnum, casePartyStatus } from '@/helpers/enum';

export default {
  name: 'PartiesInfoCard',
  components: {},
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      casePartyRoleEnum,
      casePartyStatus,
    };
  },
  computed: {
    casePartyRoleTextColor() {
      let color = null;
      const roles = [2, 5, 10, 11, 2000];
      if (roles.some(r => r == this.party.casePartyRole)) {
        color = 'white';
      }
      return color;
    },
    casePartyRoleChipColor() {
      let color = null;
      switch (this.party.casePartyRole) {
        case 2:
          color = '#5f0808';
          break;
        case 5:
          color = '#cd6133';
          break;
        case 10:
          color = '#34ace0';
          break;
        case 11:
          color = '#cc8e35';
          break;
        case 2000:
          color = '#706fd3';
          break;
      }
      return color;
    },
  },
};

</script>

